import { useLanguage } from '@/hooks/use-language.hook';
import type { SupportedLocale } from '@/lib/i18n/config';
import { Check, Language } from '@mui/icons-material';
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip
} from '@mui/material';
import {
  bindMenu,
  bindTrigger,
  usePopupState
} from 'material-ui-popup-state/hooks';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageSwitcher: FunctionComponent = () => {
  const { t } = useTranslation();
  const { language, setLanguage, available } = useLanguage();
  const popupState = usePopupState({
    variant: 'popover',
    popupId: 'language-switcher'
  });

  const handleSelect = (locale: SupportedLocale) => {
    setLanguage(locale);
    popupState.close();
  };

  return (
    <>
      <Tooltip title={t('common:languageSwitcher.tooltip')}>
        <IconButton
          aria-label={t('common:languageSwitcher.menuLabel')}
          {...bindTrigger(popupState)}
        >
          <Language />
        </IconButton>
      </Tooltip>
      <Menu
        {...bindMenu(popupState)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {available.map(({ code, label }) => (
          <MenuItem
            key={code}
            selected={code === language}
            onClick={() => handleSelect(code)}
          >
            <ListItemIcon sx={{ minWidth: 28 }}>
              {code === language ? <Check fontSize="small" /> : null}
            </ListItemIcon>
            <ListItemText>{label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
